module.exports = __webpack_public_path__ + "media/images/icons/outlined/align-center-7a406f26745aac7369a3f38cc8c0fa1e.svg";